import * as React from 'react'

import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import { trackEvent } from '../../../../../lib/analytics'
import { intlPrettyCurrency } from '../../../../../lib/utils'
import { ProductDetailsContainer } from '../contexts/ProductDetailsContainer'
import { ProductPageProduct } from '../hooks/types/ProductPageProduct'

import { StyleLinks } from './StyleLinks'
import {
  BadgesSection,
  BadgesSectionContainer,
  Container,
  MarkedDownPrice,
  Price,
  PriceDetails,
} from './styles'

export const ProductHighlights: React.FC = () => {
  const {
    featuredProduct,
    price,
    priceExplicitFmt,
    discountPrice,
    discountPriceExplicitFmt,
    productGroup,
  } = ProductDetailsContainer.useContainer()

  const { locale, region } = useLocalization()
  const embroideryService = EmbroideryService.useContainer()

  const badges = featuredProduct?.badgeList || []

  const priceRange = featuredProduct.priceRange

  const haveEmbroideryOptionsBeenSelected =
    Object.keys(embroideryService.selectedEmbroideryFormOptions ?? {}).length > 0

  const isProductFinalSale = ProductPageProduct.isProductFinalSale(featuredProduct)

  const priceAmount = price?.price?.amount
  const priceBaseAmount = price?.price?.base?.amount

  const filteredArray = badges.filter(item => item.toLowerCase() !== 'final sale')
  const isFinalSaleExist = badges.length !== filteredArray.length || !!isProductFinalSale

  return (
    <Container>
      <PriceDetails>
        {priceAmount !== undefined ? (
          <>
            {discountPrice !== undefined && (
              <MarkedDownPrice className='money'>
                {discountPriceExplicitFmt ??
                  intlPrettyCurrency({ cents: discountPrice!, region: region, locale: locale })}
              </MarkedDownPrice>
            )}
            <Price
              className='money'
              data-testid='product-highlights-price'
              styleAsMarkedDownPrice={discountPrice !== undefined}
              {...trackEvent({
                category: 'product details',
                action: 'snapshot',
                label: 'price',
                value: priceBaseAmount !== undefined ? `${priceBaseAmount / 100}` : undefined,
              })}
            >
              {priceExplicitFmt ??
                intlPrettyCurrency({ cents: priceAmount, region: region, locale: locale })}
            </Price>
          </>
        ) : (
          <>
            {priceRange ? (
              <Price className='money'>
                {`${intlPrettyCurrency({
                  cents: priceRange.min,
                  region: region,
                  locale: locale,
                })} - ${intlPrettyCurrency({
                  cents: priceRange.max,
                  region: region,
                  locale: locale,
                })}`}
              </Price>
            ) : null}
          </>
        )}
        {(isFinalSaleExist || haveEmbroideryOptionsBeenSelected) && (
          <BadgesSection badges={['final sale']} />
        )}
      </PriceDetails>
      {filteredArray.length > 0 && (
        <BadgesSectionContainer>
          <BadgesSection badges={filteredArray} />
        </BadgesSectionContainer>
      )}
      <StyleLinks productGroupHandle={productGroup.handle} />
    </Container>
  )
}
